(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-feedback-content"] && !window.DesignMode) return;
  try {
    

//------------------//

// get Masonry instance

let currentIndex = 0;
const itemsPerPage = 12;
let allData = [];

function addLoadingPlaceholders() {
  const $gridElement = $('.cf-grid');
  const placeholderb64 = [
    {width: 500, height: 1000, uri: "iVBORw0KGgoAAAANSUhEUgAAAAIAAAAECAQAAAAO5iayAAAAEElEQVR42mNc8J+BgRGVAABG3AaB77phzQAAAABJRU5ErkJggg=="},
    {width: 500, height: 500, uri: "iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAQAAADYv8WvAAAAD0lEQVR42mNcUM/AwAgiAA2uAkFTveFkAAAAAElFTkSuQmCC"},
    {width: 500, height: 750, uri: "iVBORw0KGgoAAAANSUhEUgAAAAIAAAADCAQAAAAT4xYKAAAAD0lEQVR42mNcUM/AwAgnABz1A2GpSZD1AAAAAElFTkSuQmCC"}
  ];

  for(let i = 0; i < 12; i++) { // Add 12 placeholders
    const widthPx = 500;  // Fixed width of 500 pixels
    const heightPx = Math.floor(Math.random() * 401 + 500); // Random height between 500px and 900px

    // Randomly pick a base64 string from the array
    const randomIndex = Math.floor(Math.random() * placeholderb64.length);

    const placeholder = `
      <div class="cf-grid-item loading-placeholder">
        <img 
        width="${placeholderb64[randomIndex]['width']}px"
        height="${placeholderb64[randomIndex]['height']}px"
        src="data:image/png;base64,${placeholderb64[randomIndex]['uri']}" 
        alt="Loading...">
      </div>
    `;

    const $placeholder = $(placeholder);
    $gridElement.append($placeholder).masonry('appended', $placeholder);
    $gridElement.masonry('layout');
    

  }
}

let $grid
  
function initializeMasonry() {
  $grid = $('.cf-grid').masonry({
    itemSelector: '.cf-grid-item',
    columnWidth: '.cf-grid-sizer',
    stagger: 30,
    resize: true,
    percentPosition: true,
    visibleStyle: { transform: 'translateY(0)', opacity: 1 },
    hiddenStyle: { transform: 'translateY(20px)', opacity: 0 },
  });

}

function loadNextItems() {
  const $gridElement = $('.cf-grid');
  const msnry = $gridElement.data('masonry');

  const nextItems = allData.slice(currentIndex, currentIndex + itemsPerPage);
  currentIndex += itemsPerPage;

  if (nextItems.length === 0) {
    return;
  }

  nextItems.forEach(function(chunk) {
    let itemsHTML = getItemHTML(chunk);
    let $items = $(itemsHTML);
    $gridElement.append($items).masonry('appended', $items);
    $gridElement.masonry('layout');
  });

  $('.cfl-grid').remove();
  // $gridElement.masonry('layout');
}

function setupScrollListener() {  
  $(window).scroll(function() {
    if ($(window).scrollTop() + $(window).height() > $(document).height() - 100) { // 100px from bottom
      loadNextItems();
    }
  });
}

  
function getItemHTML(entry) {
  return `<div class="cf-grid-item rating-${entry.quality}" data-metaid="${entry.id}">
        <img 
             width="${entry.imageWidth}"
             height="${entry.imageHeight}"
			 src="${entry.imageUrl}"
			 alt="${entry.description}">
  </div>`;
}
      
//Monitor for clicks on grid images. On click, we will grab sister images, set lightbox values, and open..
$('.cf-grid').on('click', '.cf-grid-item', function() {
  const metaId = $(this).data('metaid');
  const imageUrl = getUrlFromImageId(metaId);

  if (imageUrl) {
    const lightbox = new FsLightbox();
    lightbox.props.type = 'image';
    lightbox.props.captions = ['This is a description'];
    lightbox.props.sources = [imageUrl];
    console.log(metaId);
    lightbox.open();
  } else {
    console.error('Image URL not found for metaId:', metaId);
  }
});

function getUrlFromImageId(metaId) {
  const imageObject = allData.find(item => item.id === metaId);
  return imageObject ? imageObject.imageUrl_xl : null;
}

$(document).ready(async function() {
  try {
    initializeMasonry();
    const response = await fetch('https://edgeright-feedback-content.lewisbamboo.workers.dev/api');
    if (!response.ok) {
      throw new Error('Network response was not ok ' + response.statusText);
    }
    allData = await response.json();

    loadNextItems();
    setupScrollListener();

    allData.forEach(item => {
      const img = new Image();
      img.src = item.imageUrl;

      const imgXl = new Image();
      img.src = item.imageUrl_xl;
    });
  } catch (error) {
    console.error('There has been a problem with your fetch operation:', error);
  }
});



  } catch(e) { console.error(e); }
})();
})();
